import { Modal, ModalProps } from '@/components/modal'

export const AddPlayerOnMobileModal = (props: ModalProps): JSX.Element => {
  return (
    <Modal
      customStyles={{
        content: {
          padding: '48px 35px',
          width: '600px',
        },
      }}
      {...props}
    >
      <h3 className="mb-[15px] mt-[10px] text-center text-2xl font-bold tracking-widest text-primary-text">
        プレイヤーの追加
      </h3>
      <div>
        <div className="mt-4 px-4 pb-[21px] text-center text-[15px] text-secondary-text">
          <p>プレイヤーの追加は、学習者アプリからご対応いただけます。</p>
        </div>
      </div>
    </Modal>
  )
}
